'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _reactS3Uploader = require('react-s3-uploader');

var _reactS3Uploader2 = _interopRequireDefault(_reactS3Uploader);

var _nukaCarousel = require('nuka-carousel');

var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactTappable = require('react-tappable');

var _reactTappable2 = _interopRequireDefault(_reactTappable);

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _components = require('components');

var _CarouselDecorator = require('./CarouselDecorator/CarouselDecorator.js');

var _CarouselDecorator2 = _interopRequireDefault(_CarouselDecorator);

var _S3FileUploader = require('../../helpers/S3FileUploader');

var _S3FileUploader2 = _interopRequireDefault(_S3FileUploader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropZone = function (_Component) {
  (0, _inherits3.default)(DropZone, _Component);

  function DropZone(props) {
    (0, _classCallCheck3.default)(this, DropZone);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(DropZone).call(this, props));

    _this2.state = {
      progress: 0,
      error: {
        display: false,
        message: ''
      },
      displayUrlPicker: false,
      displayInstagramPicker: false,
      pics: _this2.props.pics
    };

    _this2.onDrop = _this2.onDrop.bind(_this2);
    return _this2;
  }

  (0, _createClass3.default)(DropZone, [{
    key: 'onDrop',
    value: function onDrop(files) {
      var _this3 = this;

      var uploader = new _S3FileUploader2.default(files[0]);

      uploader.on('progress', function (percent) {
        _this3.setState({ progress: percent });
      });

      uploader.on('complete', function (result) {
        _this3.setState({
          progress: 0
        });
        _this3.props.onComplete(result.filename);
      });

      uploader.on('error', function (status) {
        _this3.setState({ error: status, progress: null });
      });

      return _bluebird2.default.resolve().then(function () {
        console.log('is image ?');
        if (uploader.isImage()) {
          return uploader.start();
        } else {
          (function () {
            _this3.setState({ error: { display: true, message: 'Not a valid file type (image only)' } });
            var _this = _this3;
            setTimeout(function () {
              _this.setState({ error: { display: false, message: '' } });
            }, 5000);
          })();
        }
        console.log('hello');
      }).finally(function () {
        _this3.setState({ uploading: false });
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.pics !== this.state.pics) {
        this.setState({ pics: newProps.pics });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var styles = require('./DropZone.scss');
      var baseUrl = 'https://s3.amazonaws.com/outfeats/';
      var _state = this.state;
      var progress = _state.progress;
      var pics = _state.pics;
      var error = _state.error;

      var settings = {
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        cellAlign: 'center'
      };

      //let instaPics = []; // this.props.instagramPics;
      // for(let i=0; i<20; i++) {
      //   instaPics.push(i);
      // }
      // console.log('render dropzone');
      // console.log(progress);
      // console.log(pics.length);
      // console.log(error.display);

      var instaPics = this.props.instagramPics;

      return _react2.default.createElement(
        _reactDropzone2.default,
        {
          disableClick: true,
          ref: 'dropzone',
          multiple: false,
          className: styles.container,
          activeClassName: styles.active,
          onDrop: this.onDrop },
        _react2.default.createElement(
          'div',
          { className: styles.content },
          progress == 0 && pics.length == 0 && error.display == false && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)(styles.default, 'hide-small') },
              _react2.default.createElement('div', { className: styles.animation }),
              _react2.default.createElement(
                'p',
                null,
                'Drag & drop a picture of your outfit.'
              ),
              _react2.default.createElement(
                'small',
                { onClick: function onClick() {
                    return _this4.refs.dropzone.open();
                  } },
                'or click here to browse...'
              )
            ),
            _react2.default.createElement(
              _reactTappable2.default,
              { onTap: function onTap() {
                  return _this4.refs.dropzone.open();
                } },
              _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(styles.default, 'display-small') },
                _react2.default.createElement(
                  'div',
                  { className: styles.uploadContainer },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Upload a picture of your outfit'
                  )
                )
              )
            )
          ),
          progress > 0 && _react2.default.createElement(
            'div',
            { className: styles.progress },
            _react2.default.createElement(
              'h3',
              null,
              this.state.progress,
              _react2.default.createElement(
                'small',
                null,
                '%'
              )
            )
          ),
          error.display === true && _react2.default.createElement(
            'div',
            { className: styles.error },
            _react2.default.createElement(
              'h3',
              null,
              error.message
            )
          ),
          pics.length > 0 && _react2.default.createElement(
            'div',
            { className: styles.slider },
            _react2.default.createElement(
              _nukaCarousel2.default,
              (0, _extends3.default)({}, settings, { onPlus: function onPlus() {
                  return console.log('plus');
                }, decorators: _CarouselDecorator2.default }),
              pics.map(function (pic) {
                return _react2.default.createElement(
                  'div',
                  { className: styles.pic, key: pic },
                  _react2.default.createElement(
                    'div',
                    { className: styles.imageContainer },
                    _react2.default.createElement('img', { src: baseUrl + pic }),
                    _react2.default.createElement(
                      'button',
                      { onClick: function onClick() {
                          return _this4.props.onDelete(pic);
                        }, className: styles.remove },
                      'Delete image'
                    )
                  )
                );
              })
            ),
            _react2.default.createElement(
              'a',
              { onClick: function onClick() {
                  return _this4.refs.dropzone.open();
                }, className: styles.plus, style: { position: 'absolute', bottom: '22px', left: 'calc(50% + ' + (40 + 40 * pics.length) / 2 + 'px)' } },
              '+'
            )
          )
        ),
        false && _react2.default.createElement(
          'div',
          { className: styles.choices },
          'or even ',
          _react2.default.createElement(
            'a',
            { onClick: function onClick() {
                _this4.setState({ displayUrlPicker: true });
                var _this = _this4;
                setTimeout(function () {
                  _this.refs.urlPicker.getDOMNode().focus();
                }, 550);
              } },
            'paste an url'
          ),
          ' or ',
          _react2.default.createElement(
            'a',
            { onClick: function onClick() {
                return _this4.setState({ displayInstagramPicker: true });
              } },
            'pick from your instagram pics'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(styles.urlPicker, styles.picker, (0, _defineProperty3.default)({}, styles.isShown, this.state.displayUrlPicker)) },
          _react2.default.createElement(
            'button',
            { className: styles.close, onClick: function onClick() {
                return _this4.setState({ displayUrlPicker: false });
              } },
            _react2.default.createElement('i', { className: 'ion-android-close' })
          ),
          _react2.default.createElement('input', { type: 'text', ref: 'urlPicker', placeholder: 'Paste the url to your outift picture' }),
          _react2.default.createElement(
            'button',
            { className: styles.addButton },
            '+'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('instagramSlider', styles.instagramPicker, styles.picker, (0, _defineProperty3.default)({}, styles.isShown, this.state.displayInstagramPicker)) },
          _react2.default.createElement(_components.InstagramPicker, {
            onSelected: function onSelected(selected) {
              return console.log(selected);
            },
            pics: instaPics,
            onClose: function onClose() {
              return _this4.setState({ displayInstagramPicker: false });
            } })
        )
      );
    }
  }]);
  return DropZone;
}(_react.Component);

exports.default = DropZone;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DropZone/DropZone.js
 ** module id = 1089
 ** module chunks = 0
 **/